import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { analytics } from "@silvertours/front-entities";
import { Banner } from "@silvertours/front-legacy-entities";
import { UiLegacy } from "@silvertours/front-legacy-shared";
import { Ui } from "@silvertours/front-shared";
import { useTranslations } from "next-intl";
import { ButtonContainer } from "./AppInstallBanner.styles";
export var AppInstallBanner = function(param) {
    var isShowing = param.isShowing, onClose = param.onClose;
    var t = useTranslations("features.mobileAppPromotionLegacy");
    var promoTitle = t("globalApptrafficPromoTitle");
    return /*#__PURE__*/ _jsx(UiLegacy.ForegroundLayer, {
        id: "app-install-banner",
        isShowing: isShowing,
        onClose: onClose,
        children: /*#__PURE__*/ _jsx(Banner, {
            title: promoTitle,
            children: /*#__PURE__*/ _jsxs(ButtonContainer, {
                children: [
                    /*#__PURE__*/ _jsx(Ui.PlayStoreLink, {
                        id: "app-install-banner-play-store-anchor",
                        href: t("playStoreLink"),
                        onClick: analytics.gtm.trackIosAppLinkClicked
                    }),
                    /*#__PURE__*/ _jsx(Ui.AppStoreLink, {
                        id: "app-install-banner-app-store-anchor",
                        href: t("appStoreLink"),
                        onClick: analytics.gtm.trackIosAppLinkClicked
                    })
                ]
            })
        })
    });
};
